// --------------- Submenus ---------------
const navItems = document.querySelectorAll(
  `.main-nav__item[data-menu-level="0"]`
);
const contentOverlay = document.querySelector("#content-overlay");

navItems?.forEach((item) => {
  const submenuContainer = item.querySelector(".main-nav__submenu-container");

  // on hover
  item.addEventListener("mouseenter", () => {
    hideAllSubmenus(); // Hide all other submenus first
    if (submenuContainer) {
      toggleContentOverlay(true); // Show content overlay
      showSubmenu(submenuContainer);
    }
  });

  // on focus
  item.addEventListener("focus", () => {
    hideAllSubmenus(); // Hide all other submenus first
    if (submenuContainer) {
      toggleContentOverlay(true); // Show content overlay
      showSubmenu(submenuContainer);
    }
  });

  // on mouseleave (hover end)
  submenuContainer?.addEventListener("mouseleave", () => {
    hideSubmenu(submenuContainer);
  });

  // on blur (focus end)
  submenuContainer?.addEventListener("blur", () => {
    hideSubmenu(submenuContainer);
  });
});

// Hide all submenus when clicking on the content overlay
contentOverlay?.addEventListener("click", () => hideAllSubmenus());

document?.addEventListener("DOMContentLoaded", () =>
  toggleContentOverlay(false)
);

/**
 * Helper function to toggle the content overlay.
 * @param {boolean} visible Should the overlay get visible or not
 */
function toggleContentOverlay(visible = false) {
  if (contentOverlay) {
    if (visible) {
      contentOverlay.style.opacity = 1;
      // contentOverlay.style.transitionDelay = "0s";
      contentOverlay.setAttribute("aria-hidden", "false");
    } else {
      contentOverlay.style.opacity = 0;
      // contentOverlay.style.transitionDelay = "0.15s";
      contentOverlay.setAttribute("aria-hidden", "true");
    }
  }
}

/**
 * Helper function to show the submenu of a menu item.
 * @param {Element} submenuContainer Submenu Container
 * @returns
 */
function showSubmenu(submenuContainer) {
  if (!submenuContainer) return; // Fallback

  // Show submenu by JS only on tablets and desktops
  if (typeof window !== "undefined" && window.innerWidth > 1100) {
    submenuContainer.style.maxHeight = `${submenuContainer.scrollHeight}px`;
    submenuContainer.setAttribute("aria-hidden", "false");
  }
}

/**
 * Helper function to hide the submenu of a menu item.
 * @param {Element} submenuContainer Submenu Container
 * @returns
 */
function hideSubmenu(submenuContainer) {
  if (!submenuContainer) return; // Fallback

  // Show submenu by JS only on tablets and desktops
  if (typeof window !== "undefined" && window.innerWidth > 1100) {
    toggleContentOverlay(false); // Hide content overlay
    submenuContainer.style.maxHeight = 0;
    submenuContainer.setAttribute("aria-hidden", "true");
  }
}

/**
 * Helper function that loops through all menu items hides their submenus.
 */
function hideAllSubmenus() {
  navItems?.forEach((item) => {
    const submenuContainer = item.querySelector(".main-nav__submenu-container");
    if (submenuContainer) hideSubmenu(submenuContainer);
  });
}

// --------------- Main Nav Toggle ---------------
const navToggle = document.querySelector("#main-nav-toggle");
const mainNavContainer = document.querySelector("#main-nav-container");

navToggle?.addEventListener("click", () => {
  const body = document.body;
  if (!body.classList.contains("main-nav-toggled")) {
    // Show nav
    body.classList.add("main-nav-toggled");
    body.classList.add("overflow-hidden");
    navToggle.setAttribute("aria-pressed", "true");
    navToggle.setAttribute("aria-label", "Navigation ausblenden");
    navToggle.setAttribute("title", "Navigation ausblenden");
    mainNavContainer.style.maxHeight = `100vh`;
  } else {
    // Hide nav
    body.classList.remove("main-nav-toggled");
    body.classList.remove("overflow-hidden");
    navToggle.setAttribute("aria-pressed", "false");
    navToggle.setAttribute("aria-label", "Navigation einblenden");
    navToggle.setAttribute("title", "Navigation einblenden");
    mainNavContainer.style.maxHeight = 0;
  }
});
